"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedAvatarGroup = void 0;
var styles_1 = require("@mui/material/styles");
var AvatarGroup_1 = __importDefault(require("@mui/material/AvatarGroup"));
exports.ThemedAvatarGroup = (0, styles_1.styled)(AvatarGroup_1.default)(function (_a) {
    var theme = _a.theme, size = _a.size, _b = _a.bordercolor, bordercolor = _b === void 0 ? 'light' : _b;
    return ({
        width: 'fit-content',
        marginLeft: '1.6rem',
        '.MuiAvatarGroup-avatar': __assign(__assign(__assign(__assign(__assign(__assign({ width: '4.0rem', height: '4.0rem', backgroundColor: theme.palette.primary[500], fontWeight: 'bold', border: '2px solid' }, (bordercolor === 'light' && {
            borderColor: theme.palette.common.white,
        })), (bordercolor === 'dark' && {
            borderColor: theme.palette.primary[600],
        })), (size === 'xsmall' && {
            width: '2.5rem',
            height: '2.5rem',
            fontSize: '1.4rem',
        })), (size === 'small' && {
            width: '3.2rem',
            height: '3.2rem',
            fontSize: '1.8rem',
        })), (size === 'medium' && {
            width: '4.0rem',
            height: '4.0rem',
            fontSize: '1.8rem',
        })), (size === 'large' && {
            width: '8.6rem',
            height: '8.6rem',
            fontSize: '2.8rem',
        })),
    });
});
